import { render, staticRenderFns } from "./ArticleViewMp.vue?vue&type=template&id=a27a1ca2&scoped=true&"
import script from "./ArticleViewMp.vue?vue&type=script&lang=js&"
export * from "./ArticleViewMp.vue?vue&type=script&lang=js&"
import style0 from "./ArticleViewMp.vue?vue&type=style&index=0&id=a27a1ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27a1ca2",
  null
  
)

export default component.exports